export default __webpack_public_path__ + "static/media/ProductSans-Black.bb450f95.eot";